import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/window-minimize': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 480h-448c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-minimize.js
// module id = 1835
// module chunks = 0